/**
 * Show Kanal WhatsApp widget only after user has scrolled 40% of the page.
 * Once visible, it stays visible (class is never removed).
 */
(function () {
  var THRESHOLD_PERCENT = 40;
  var ticking = false;
  var visible = false;

  function getScrollPercent() {
    var scrollTop = window.scrollY || document.documentElement.scrollTop;
    var scrollHeight = document.documentElement.scrollHeight;
    var clientHeight = window.innerHeight;
    var maxScroll = scrollHeight - clientHeight;

    if (maxScroll <= 0) return 100; // Short page: consider fully scrolled
    var percent = (scrollTop / maxScroll) * 100;
    return isNaN(percent) ? 0 : Math.min(100, Math.max(0, percent));
  }

  function updateVisibility() {
    if (visible) {
      ticking = false;
      return;
    }
    var percent = getScrollPercent();
    if (percent >= THRESHOLD_PERCENT) {
      document.body.classList.add('kanal-whatsapp-visible');
      visible = true;
      window.removeEventListener('scroll', onScroll);
    }
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(updateVisibility);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updateVisibility();
      window.addEventListener('scroll', onScroll, { passive: true });
    });
  } else {
    updateVisibility();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();